module.exports = __webpack_public_path__ + "img/fondo-amaro.346b8ec2.jpg";